import { create } from "zustand";
import { persist } from "zustand/middleware";

const useFolderStore = create(
  persist(
    (set, get) => ({
      folders: [],
      lastFetched: null,
      isRefreshing: false,

      setFolders: (folders) =>
        set({ folders: folders.slice(0, 50), lastFetched: Date.now() }),

      mergeFolders: (freshFolders) => {
        const existing = get().folders;
        const map = new Map(existing.map((f) => [f.id, f]));
        freshFolders.forEach((f) => map.set(f.id, f));
        set({ folders: Array.from(map.values()).slice(0, 50), lastFetched: Date.now() });
      },

      setRefreshing: (val) => set({ isRefreshing: val }),
      clearFolders: () => set({ folders: [], lastFetched: null }),
    }),
    {
      name: "folder-cache",
      partialize: (state) => ({
        folders: state.folders,
        lastFetched: state.lastFetched,
      }),
    }
  )
);

export default useFolderStore;
